import { IEntryDTO, IEntryFieldDTO, IEntryOptionDTO, IEntrySectionDTO } from '@/dtos';
import { post, remove } from '../apiWrapper';

export const createEntryForYearAPI = async (yearId: string): Promise<IEntryDTO> => {
  const ret = await post<IEntryDTO>(`/admin/year/${yearId}/entry/createe`);
  return ret;
};

export const updateEntryAPI = async (entry: IEntryDTO): Promise<IEntryDTO> => {
  const ret = await post<IEntryDTO>(`/admin/entry/${entry.id}'`, entry);
  return ret;
};

export const createSectionAPI = async (section: IEntrySectionDTO): Promise<IEntrySectionDTO> => {
  const ret = await post<IEntrySectionDTO>(`/admin/entry/sections/create`, section);
  return ret;
};

export const updateSectionsAPI = async (
  entryId: string,
  sections: IEntrySectionDTO[],
): Promise<{ data: IEntrySectionDTO[]; count: number }> => {
  const ret = await post<{ data: IEntrySectionDTO[]; count: number }>(
    `/admin/entry/${entryId}/sections`,
    sections,
  );
  return ret;
};
export const deleteSectionAPI = async (section: IEntrySectionDTO): Promise<boolean> => {
  const ret = await remove<boolean>(`/admin/entry/section/${section.id}`);
  return ret;
};

export const createFieldAPI = async (field: IEntryFieldDTO): Promise<IEntryFieldDTO> => {
  const ret = await post<IEntryFieldDTO>(`/admin/entry/fields/create`, field);
  return ret;
};
export const deleteFieldAPI = async (field: IEntryFieldDTO): Promise<boolean> => {
  const ret = await remove<boolean>(`/admin/entry/field/${field.id}`);
  return ret;
};

export const updateFieldsAPI = async (
  entryId: string,
  sectionId: string,
  fields: IEntryFieldDTO[],
): Promise<{ data: IEntryFieldDTO[]; count: number }> => {
  const ret = await post<{ data: IEntryFieldDTO[]; count: number }>(
    `/admin/entry/${entryId}/section/${sectionId}/fields`,
    fields,
  );
  return ret;
};

export const createOption = async (option: IEntryOptionDTO): Promise<IEntryOptionDTO> => {
  const ret = await post<IEntryOptionDTO>(`/admin/entry/option/create`, option);
  return ret;
};
